import { css } from "@emotion/react";


export const emotionGlobalCss = css`

@media screen and (max-device-width: 480px){
    .MuiModal-root{
      -webkit-text-size-adjust: 100%;
    }
  }

`  